import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import chartsSrc from './charts-series-detail.svg';

export const PipelineData = ({ openChart, pipelineSummary, modelId, mini }) => (
  <div className={styles.pipelineData} id="pipelineDataSummary">
    {pipelineSummary.map(({ description, total }, index) => {
      return (
        <div className={styles.status} key={`${modelId}${index}`}>
          <span className={styles.total}> {total} </span>
          <span className={mini ? styles.statusMiniTitle : styles.statusTitle}>
            {' '}
            {description}{' '}
          </span>
        </div>
      );
    })}
    <img
      src={chartsSrc}
      alt="open chart"
      onClick={openChart}
      className={styles.openChart}
    />
  </div>
);

export default enhance(PipelineData);
